import { render, staticRenderFns } from "./Observation.vue?vue&type=template&id=36920c6a&scoped=true"
import script from "./Observation.vue?vue&type=script&lang=js"
export * from "./Observation.vue?vue&type=script&lang=js"
import style0 from "./Observation.vue?vue&type=style&index=0&id=36920c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36920c6a",
  null
  
)

export default component.exports